<template>
  <div class="flex justify-content-start space-x-1">
    <span class="inline-flex items-center justify-center py-1 px-2 mr-2 text-xs font-bold leading-none rounded-full text-white bg-blue-600 ">Ativo</span>
    <span class="inline-flex items-center justify-center py-1 px-2 mr-2 text-xs font-bold leading-none rounded-full  text-white bg-red-600 ">Bloqueado</span>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
</style>
